import React, { useEffect, useState } from "react";
import {
    Card, CardBody, Row, Col, Input, Button, Table,
    Modal, ModalHeader, ModalBody, ModalFooter, Label
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import Pagination from "../../Helpers/Pagination";
import { toast } from "react-toastify";
import "boxicons/css/boxicons.min.css";
import { formatIST, getCookie } from "../../Helpers/Utils";
import { useNavigate } from "react-router-dom";

const CustomerList = () => {

    const dispatch = useDispatch();
    const user = useSelector(state => state.customer.customer);
    const navigate = useNavigate()
    const loading = useSelector(state => state.loading.loading);
    const [rows, setRows] = useState([]);
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const limit = 10;

    /* MODAL */
    const [modal, setModal] = useState(false);
    const [editId, setEditId] = useState(null);
    const [form, setForm] = useState({ name: "", phone: "" });

    /* 🔹 LOYALTY POINTS STATE (NEW) */
    const [pointsMap, setPointsMap] = useState({}); // customer_id => balance

    const toggle = () => setModal(!modal);
    const onChange = e => setForm({ ...form, [e.target.name]: e.target.value });

    /* LOAD CUSTOMERS */
    const load = async () => {
        dispatch(loadingTrue());
        const res = await Handler({
            method: "get",
            url: `/customers/search_cus.php?outlet_id=${user?.outlet_id}&q=${search}`
        });
        if (res?.success) setRows(res.data || []);
        else toast.error(res?.message || "Failed to load customers");
        dispatch(loadingFalse());
    };

    useEffect(() => { load(); }, [search]);

    const openEdit = (c) => {
        setEditId(c.id);   // ✅ store only id
        setForm({ name: c.name, phone: c.phone });
        setModal(true);
    };

    /* ADD / UPDATE */
    const submit = async () => {
        if (!form.name) return toast.error("Name required");
        if (!form.phone) return toast.error("Phone required");
        if (!/^[0-9]{10}$/.test(form.phone)) return toast.error("Invalid phone");

        dispatch(loadingTrue());
        const url = editId ? "/customers/update.php" : "/customers/add.php";
        const payload = { ...form, outlet_id: user?.outlet_id, customer_id: editId, id: editId };

        const res = await Handler({ method: "post", url, data: payload });
        if (res?.success) {
            toast.success(editId ? "Customer updated" : "Customer added");
            setModal(false);
            setEditId(null);
            setForm({ name: "", phone: "" });
            load();
        } else toast.error(res?.message || "Action failed");
        dispatch(loadingFalse());
    };

    /* EDIT OPEN */


    /* 🔹 EXPORT CUSTOMERS CSV */
    const exportCustomers = async () => {
        const token = getCookie("token");
        if (!token) return toast.error("Login expired");

        const q = search || "";
        const url = `https://demos.billpro360.com/bill/apis` + `/customers/download_csv.php?outlet_id=${user.outlet_id}&q=${encodeURIComponent(q)}`;
        // const url = `http://localhost/bill_backend_production/apis` + `/customers/download_csv.php?outlet_id=${user.outlet_id}&q=${encodeURIComponent(q)}`;
        // const url = `http://localhost/bill-with-quotation/apis` + `/customers/download_csv.php?outlet_id=${user.outlet_id}&q=${encodeURIComponent(q)}`;

        const res = await fetch(url, {
            headers: {  
                Authorization: `Bearer ${token}`
            }
        });

        if (!res.ok) {
            toast.error("Unauthorized");
            return;
        }

        const blob = await res.blob();
        const fileURL = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = fileURL;
        a.download = "customers.csv";
        document.body.appendChild(a);
        a.click();
        a.remove();
    };

    /* 🔹 CHECK LOYALTY POINTS (NEW) */
    const checkPoints = async (customerId) => {
        dispatch(loadingTrue());
        try {
            const res = await Handler({
                method: "post",
                url: "/loyalty_points/balance.php",
                data: {
                    customer_id: customerId,
                    outlet_id: user?.outlet_id
                }
            });

            if (res?.success) {
                setPointsMap(p => ({
                    ...p,
                    [customerId]: res.data.balance
                }));
            } else toast.error(res?.message || "Failed to fetch points");
        } catch {
            toast.error("Network error");
        }
        dispatch(loadingFalse());
    };

    /* PAGINATION */
    const total = rows.length;
    const start = (page - 1) * limit;
    const pagedRows = rows.slice(start, start + limit);

    return (
        <>
            {/* HEADER */}
            <Row className="mb-3 align-items-center">
                <Col md={6}>
                    <h5 className="fw-bold mb-0">Customers</h5>
                    <small className="text-muted">Manage your outlet customers</small>
                </Col>
                <Col md={6} className="text-end">
                    <Button
                        disabled={loading}
                        color="outline-primary"
                        className="me-2"
                        onClick={exportCustomers}
                    >
                        <i className="bx bx-download"></i> Export CSV
                    </Button>
                    <Button
                        disabled={loading}
                        className="list-add-btn d-inline-flex align-items-center gap-1"
                        onClick={() => { setEditId(null); setForm({ name: "", phone: "" }); toggle(); }}
                    >
                        <i className="bx bx-plus"></i> Add Customer
                    </Button>
                </Col>
            </Row>

            {/* SEARCH */}
            <Card className="mb-3">
                <CardBody>
                    <Input
                        placeholder="Search by name or phone..."
                        value={search}
                        onChange={e => { setSearch(e.target.value); setPage(1); }}
                    />
                </CardBody>
            </Card>

            {/* TABLE */}
            <Card>
                <CardBody>
                    <Table responsive borderless className="modern-table">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Name</th>
                                <th>Phone</th>
                                <th>Joined</th>
                                <th className="text-end">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pagedRows.length ? pagedRows.map((c, i) => (
                                <tr key={i}>
                                    <td>{start + i + 1}</td>
                                    <td>{c.name}</td>
                                    <td>{c.phone}</td>
                                    <td>
                                        {/* {new Date(c.created_at).toLocaleDateString()} */}
                                        {formatIST(c?.created_at)}
                                    </td>
                                    <td className="text-end">
                                        <Button
                                            disabled={loading}
                                            size="sm"
                                            color="light"
                                            className="me-2"
                                            onClick={() => openEdit(c)} // Inga 'c.id' ku badhula 'c' nu pass pannu
                                        >
                                            <i className="bx bx-edit"></i>
                                        </Button>

                                        {/* 🔹 CHECK POINTS BUTTON */}
                                        <Button
                                            disabled={loading}
                                            size="sm"
                                            color="light"
                                            className="me-2"
                                            onClick={() => checkPoints(c.id)}
                                        >
                                            <i className="bx bx-star"></i> Check Loyalty Points
                                        </Button>

                                        <Button
                                            disabled={loading}
                                            size="sm"
                                            color="primary"
                                            className="me-2"
                                            onClick={() => navigate(`/customer-history/${c.id}`)}
                                        >
                                            <i className="bx bx-star"></i> History
                                        </Button>

                                        {pointsMap[c.id] !== undefined && (
                                            <span className="fw-bold text-success ms-2">
                                                {pointsMap[c.id]} pts
                                            </span>
                                        )}

                                    </td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan="5" className="text-center text-muted">
                                        No customers found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>

                    <Pagination
                        page={page}
                        total={total}
                        limit={limit}
                        onPrev={() => setPage(p => Math.max(1, p - 1))}
                        onNext={() => setPage(p => p + 1)}
                    />
                </CardBody>
            </Card>

            {/* ADD / EDIT MODAL */}
            <Modal isOpen={modal} toggle={toggle} centered>
                <ModalHeader toggle={toggle}>
                    {editId ? "Edit Customer" : "Add Customer"}
                </ModalHeader>
                <ModalBody>
                    <Label>Name</Label>
                    <Input
                        className="mb-3"
                        name="name"
                        value={form.name}
                        onChange={onChange}
                        placeholder="Customer name"
                    />
                    <Label>Phone</Label>
                    <Input
                        name="phone"
                        maxLength={10}
                        value={form.phone}
                        onChange={onChange}
                        placeholder="10 digit phone"
                    />
                </ModalBody>
                <ModalFooter>
                    <Button disabled={loading} color="light" onClick={toggle}>Cancel</Button>
                    <Button disabled={loading} color="success" onClick={submit}>
                        <i className="bx bx-save"></i> {editId ? "Update" : "Save"}
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default CustomerList;
